const tourismAdminAbility = can => {
  can('manage', 'TourismAdmin');
};

export default tourismAdminAbility;
